export enum LinkType {
    edition = 1,
    recitation = 2,
    information = 3
}



// WEBPACK FOOTER //
// ./src/app/enums/link-type.enum.ts